// src/widgets/KnowledgeWidget.tsx

import { ResponseEventWidget, ResponseEventItem, ResponseEventUpdate } from './ResponseEventWidget';
import { RealtimeEvent } from '../utils/events.js';
import { MemoryIndexes } from '../contexts/FabricServiceContext';
import { AgentDescription } from '../types/AgentDescription';

interface KnowledgeWidgetProps {

}

export const KnowledgeWidget: React.FC<KnowledgeWidgetProps> = ({

}) => {

  const displayMode = (eventItem: ResponseEventItem) => {
    return eventItem.data?.selected ? 'selected' : (eventItem.data?.selected === false ? 'unselected' : '')
  }

  const itemContent = (eventItem: ResponseEventItem) => {

    const mode = displayMode(eventItem)

    const memoryContent = (eventItem: ResponseEventItem) => {
      if (!eventItem.data) return

      return (
        <div className={`memory-content ${mode}`}>
          {eventItem.data.content}
        </div>
      )
    }

    return (
      <div className="memory-row">
        <div>
          {memoryContent(eventItem)}
        </div>
        <div className={`memory-timestamp ${mode}`}>
          {eventItem.data?.timestamp.toLocaleDateString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // hour12: true,
          })}
        </div>
      </div>
    )
  }

  const speakerName = (eventItem: ResponseEventItem) => {
    return <div className={`memory-speaker ${displayMode(eventItem)}`}>{AgentDescription(eventItem.data?.source || '', (eventItem.role === 'assistant' ? 'assistant' : undefined)).name}</div>
  }

  const filterCondition = (eventItem: ResponseEventItem, selectedModule: string, selectedFilters: (string | undefined)[]) => {
    if (selectedModule != '' && !eventItem.type.includes(selectedModule)) {
      return false;
    }
    if (selectedFilters.includes(eventItem.data?.source || '')) {
      return false;
    }
    return true
  }

  const eventUpdate = (realtimeEvent: RealtimeEvent, output: ResponseEventUpdate, memoryIndexes?: MemoryIndexes[]) => {

    const itemOutput = realtimeEvent.event.item.output[0]
    const responseId = realtimeEvent.event.response_id
    const memoryIndex = memoryIndexes?.find((index) => index.id === responseId)

    itemOutput.content.forEach((content: string[], index: number) => {

      const item: ResponseEventItem = {
        responseId: realtimeEvent.event.response_id,
        id: `${realtimeEvent.event.item.id}-${index}`,
        role: [content[1]].includes(itemOutput.sender) ? 'user' : [content[1]].includes(itemOutput.recipient) ? 'assistant' : '',
        type: 'episodic',
        output: output,
        data: {
          timestamp: new Date(content[0]),
          source: content[1],
          content: content[2],
          selected: memoryIndex ? (memoryIndex.indexes.includes(index) ? true : false) : undefined
        }
      }

      // Prevent Duplicate Items, if the item already exists
      if (!output.items.find((existingItem: ResponseEventItem) => {
        return (existingItem.data?.source === item.data?.source &&
          existingItem.data?.content === item.data?.content &&
          existingItem.data?.timestamp.getTime() === item.data?.timestamp.getTime() &&
          existingItem.responseId === item.responseId) === true
      })) {
        output.items.push(item)
      }

      output.filters.push({
        label: AgentDescription(item.data!.source, item.role === 'assistant' ? item.role : undefined).name,
        value: item.data!.source
      })
      output.modules.push(item.type)
    })

    //Sort the items by timestamp descending
    output.items.sort((a: ResponseEventItem, b: ResponseEventItem) => {
      return b.data!.timestamp.getTime() - a.data!.timestamp.getTime()
    })
  }

  return (
    <ResponseEventWidget
      eventType='memory'
      storageField='fabric_memory_agent_filters'
      placeholder='awaiting memories...'
      itemContent={itemContent}
      speakerName={speakerName}
      filterCondition={filterCondition}
      eventUpdate={eventUpdate}
    />
  )
};